import * as React from 'react';

import { ClassroomInterface } from './interfaces';

import numberSuffixBuilder from '../../modules/numberSuffixBuilder';

export const STANDARDS_REPORT_IMG_SRC = `${window.postbuildEnv.CDN_URL}/images/pages/standards_report`

// localStorage keys
export const STANDARDS_REPORT_PRACTICE_SCOPE = 'standardsReportPracticeScope'
export const STANDARDS_REPORT_MOMENTUM_SCORE_GOAL = 'standardsReportMomentumScoreGoal'

// Grade level constants
export const PRE_KINDERGARTEN = 'PreKindergarten'
export const KINDERGARTEN = 'Kindergarten'
export const OTHER = 'Other'
export const PRE_K_DISPLAY = 'Pre-K'

export const ALL_GRADE_LEVELS_FOR_DROPDOWN = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

// Get display label for a grade (just the name, no "grade" word)
// PreKindergarten -> 'Pre-K', Kindergarten stays as is, numbers unchanged
export const getGradeDisplayLabel = (grade: string): string => {
  if (grade === PRE_KINDERGARTEN) return PRE_K_DISPLAY
  return grade
}

// Format grade level with context (e.g., "1st grade", "Pre-K", "Kindergarten")
// capitalizeGrade: whether to use "Grade" vs "grade"
export const formatGradeLevelWithContext = (grade: string, lowercase: boolean=false): string => {
  if (grade === PRE_KINDERGARTEN) return PRE_K_DISPLAY
  if (grade === KINDERGARTEN) return KINDERGARTEN
  if (grade === OTHER) return OTHER
  return `${numberSuffixBuilder(grade)} ${lowercase ? 'grade' : 'Grade'}`
}

// Sort grade levels: PreKindergarten first, Kindergarten second, then numerically
export const sortGradeLevels = (a: string, b: string): number => {
  if (a === PRE_KINDERGARTEN) return -1
  if (b === PRE_KINDERGARTEN) return 1
  if (a === KINDERGARTEN) return -1
  if (b === KINDERGARTEN) return 1
  return Number(a) - Number(b)
}

// Shared empty state component for when a classroom has no students
interface NoStudentsEmptyStateProps {
  className?: string;
}

export const NoStudentsEmptyState: React.FC<NoStudentsEmptyStateProps> = ({ className = 'by-student' }) => (
  <div className={className}>
    <div className="empty-state">
      <h2>
        There are no students in the selected class
      </h2>
      <a
        className="quill-button contained medium green focus-on-light"
        href="/teachers/classrooms"
      >
        Add students
      </a>
    </div>
  </div>
)

// Helper to check if classroom has no students
export const classroomHasNoStudents = (classroom: ClassroomInterface): boolean => {
  return !classroom.students?.length
}

// Build state standard dropdown options with filtering, disabling, and sorting
export const buildStateStandardOptions = (
  filteredStateStandards: any[],
  classroom: ClassroomInterface,
  selectedGradeLevel: string | null
) => {
  return filteredStateStandards
    .filter(stateStandard => {
      if (selectedGradeLevel) {
        return stateStandard.grades?.includes(selectedGradeLevel)
      }
      return stateStandard.grades?.includes(classroom.grade) || stateStandard.classroom_ids?.includes(String(classroom.id))
    })
    .map(stateStandard => ({
      label: `${stateStandard.code} -- ${stateStandard.description}`,
      value: stateStandard.id,
      isDisabled: !stateStandard.classroom_ids?.includes(String(classroom.id))
    }))
    .sort((a, b) => Number(a.isDisabled) - Number(b.isDisabled))
}
